<template>
  <div class="container">
    <section id="editContent" class="shopContent">
      <ul class="tabMenu">
        <li
          v-for="(item, index) in menu"
          :key="index"
          class="tabItem">
          <router-link
            :to="{name: item.id}"
            :class="{ 'router-link-active': isActiveRoute(item.id) }">
            {{ locale[item.name] }}
          </router-link>
        </li>
      </ul>
      <!-- <router-link v-if="$route.name === 'shopPage' && $route.params.id"
        :to="{name: 'shopPdfLayout', params: {id: $route.params.id}}" 
        class="btn btnAuto btnWhite btnPdf">
        Export
      </router-link> -->
      <router-view :locale="locale" class="flexContent"></router-view>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Shop',
  props: [
    'locale'
  ],
  computed: {
    isActiveRoute () {
      return (id) => {
        // 기본적으로 Vue Router가 관리하는 router-link-active 유지
        if (this.$route.name === id) {
          return true
        }
        // shopPage에서도 shopList가 활성화되도록
        if (id === 'shopList' && this.$route.name === 'shopPage') {
          return true
        }
        return false
      }
    }
  },
  async created () {
    await this.$store.dispatch('admin/getCodes')
  },
  data () {
    return {
      menu: [
        {
          id: 'shopList',
          name: 'shop_list'
        },
        // {
        //   id: 'shopItem',
        //   name: '마스터 상품 관리'
        // },
        {
          id: 'shopOption',
          name: 'option_management'
        },
        {
          id: 'shopPreset',
          name: 'shop_preset'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
#editContent {
  padding: 0;
  border: none;
  background: none;
}
</style>